import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Button from "../../../ui/Button";
import Progress from "../../../ui/Progress";
import useRoomCard from "./useRoomCard";
import Appointments from "./components/Appointments";
import Availability from "./components/Availability";
import skills from "./worldskills_demo.png";
import CardOrganization from "../../../ui/CardOrganization";
import InfoDrawer from "../../../ui/InfoDrawer";
import ImageBox from "../../../ui/InfoDrawer/components/ImageBox";
import TitleField from "../../../ui/InfoDrawer/components/TitleField";
import DeviderLine from "../../../ui/InfoDrawer/components/DeviderLine";
import InfoField from "../../../ui/InfoDrawer/components/InfoField";

const useStyles = makeStyles(theme => ({
  demo: {
    marginTop: 16,
    display: "flex",
    "& img": {
      paddingRight: 10
    }
  },
  more: {
    marginTop: 24,
    marginBottom: 90,
    display: "flex",
    justifyContent: "center"
  },
  cardTitleCenter: {
    padding: "16px 0",
    borderBottom: "1px dashed #CACCD1",
    textAlign: "center",
    "& > div + div": {
      marginTop: 16,
    }
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  }
}));

const RoomInfoDrawer = ({ open, roomId, history, hideLink, handleDrawerClose }) => {
  const classes = useStyles();
  const { roomCard, getRoomCard } = useRoomCard();

  React.useEffect(() => {
    if (roomId !== -1) {
      getRoomCard(roomId);
    }
  }, [roomId]);

  const onLinkClick = () => {
    history.push(`/work/app/rooms/${roomCard.id}`);
  };

  return (
    <InfoDrawer open={open}>
      {roomCard ? <>
          <ImageBox image={(roomCard.photos && roomCard.photos.length) > 0 ? roomCard.photos[0].fileId : null}/>
          <TitleField title={roomCard.name}/>
          <Availability appointments={roomCard.appointments}/>
          <DeviderLine/>
          <InfoField name="Адрес" value={roomCard.address || 'не указан'} display={"block"}/>
          <InfoField name="Площадь" value={roomCard.area || 'не указана'}/>
          <InfoField name="Вместимость" value={roomCard.capacity || 'не указана'}/>
          {roomCard.appointments && roomCard.appointments.length > 0 && (
            <InfoField name="Ближайшие мероприятия" display={"block"} value={
              <Appointments appointments={roomCard.appointments}/>
            }/>
          )}
          <div className={classes.cardTitleCenter}>
            <Typography variant="caption" color="textSecondary">
              Информация о доступности помещения отсутствует
            </Typography>
          </div>
          {roomCard.demo && (
            <div className={classes.demo}>
              <img src={skills} alt="worldSkills"/>
              <Typography variant="body1" component="span">
                Оборудовано для проведения демо-экзамена
              </Typography>
            </div>
          )}

          <InfoField name="Организация" display={"block"} value={
            <CardOrganization orgName={roomCard.orgName} logo={roomCard.orgLogo || null}/>
          }/>

          <DeviderLine/>
          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
        </> :
        <div className={classes.progress}>
          <Progress/>
        </div>
      }
    </InfoDrawer>
  );
};

export default withRouter(RoomInfoDrawer);
